export enum ButtonStyle {
  TEXT = 'text',
  SOLID = 'solid',
}
